import { Eye, X } from "lucide-react";

export const PreviewBanner = ({ name, onExit }) => (
  <div data-testid="preview-banner" className="fixed inset-x-0 bottom-4 z-[60] mx-auto flex w-fit max-w-[94vw] items-center gap-3 rounded-full bg-slate-900 py-2 pe-2 ps-4 text-sm text-white shadow-2xl">
    <Eye className="h-4 w-4 shrink-0 text-amber-300" />
    <span className="truncate">معاينة: الأقسام والأزرار كما يراها <b>{name}</b></span>
    <button type="button" onClick={onExit} data-testid="preview-exit-btn" className="flex shrink-0 items-center gap-1 rounded-full bg-white px-3 py-1 text-xs font-bold text-slate-900 transition-colors hover:bg-amber-100">
      <X className="h-3.5 w-3.5" /> إنهاء المعاينة
    </button>
  </div>
);
